

export class PoiDetailsAddOutput implements IPoiDetailsAddOutput {
    status!: number;
    message!: string;

    constructor(data?: IPoiDetailsAddOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): PoiDetailsAddOutput {
        data = typeof data === 'object' ? data : {};
        let result = new PoiDetailsAddOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        return data; 
    }
}

export interface IPoiDetailsAddOutput {
    status: number;
    message: string;
}

